import $ from 'jquery';

const PickupPointFactory = (NewBackendService, $q, $http, endPoints, CatalogService, Dispatcher, StoreStates) => {
  'ngInject';

  const service = {
    getPickupPoints: (vasId) => $q((resolve, reject) =>
      NewBackendService.invokeWebApiGet(`${endPoints.ecommerceUrl}/vasses/${vasId}/pickup-points`, true).then((response) => {
        resolve(response);
      }, reject)),

    editPickupPoint: (pickupPoint) => $q((resolve, reject) => {

      const patch = [
        {
          op: 'replace',
          path: '/name',
          value: pickupPoint.name,
        }
      ];

      const { id, vasId } = pickupPoint;

      NewBackendService.invokeWebApiPatch(`${endPoints.ecommerceUrl}/vasses/${vasId}/pickup-points/${id}`, patch).then((response) => {
        resolve(response);
      }, reject);
    }),

    createPickupPoint: (vasId, pickupPoint) => $q((resolve, reject) => {

      NewBackendService.invokeWebApiPost(`${endPoints.ecommerceUrl}/vasses/${vasId}/pickup-points`, pickupPoint).then((response) => {
        resolve(response);
      }, reject);
    }),

    deletePickupPoint: (pickupPoint) => $q((resolve, reject) => {

      const { id, vasId } = pickupPoint;

      NewBackendService.invokeWebApiDelete(`${endPoints.ecommerceUrl}/vasses/${vasId}/pickup-points/${id}`).then((response) => {
        resolve(response);
      }, reject);
    })    
  };

  return service;
};

export default PickupPointFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/pickupPoint.factory.js
 **/